import { fileListItem } from './file_list_item';

$(() => {
  const key1 = 'show-file-info';
  const key2 = 'file-info-container';
  const key3 = 'rm-item';
  const dataTransfer = new DataTransfer();
  let counter = 0;

  $(`input[data-${key1}]`).on('change', function () {
    const $this = $(this);
    $.each($(this.files), function (index, val) {
      $($this.data(key1)).append(
        fileListItem(val.name, val.size, `data-${key3}='${dataTransfer.items.length}'`)
      );
      dataTransfer.items.add(val);
    });
    $(this).prop('files', dataTransfer.files);
    $($this.data(key2)).removeClass('d-none');
  });

  $(document).on('click', `[data-${key3}]`, function () {
    dataTransfer.items.remove($(this).data(key3));
    $(this).closest('li').remove();
    $(`input[data-${key1}]`).prop('files', dataTransfer.files);
    $(`[data-${key3}]`).each(function (index) {
      $(this).attr(`data-${key3}`, index);
    });
  });
});
